module.exports = __webpack_public_path__ + "static/media/gameEnding_1.efe1bfe0.mp3";